import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import SaveConfigPopup from '../ConfigPopups/SaveConfigPopup';
import Logout from '../User/Logout';
import LegalNote from '../LegalNote/LegalNote';
import RulesPopup from '../RulesPopup/RulesPopup';
import { PopupState } from '../../model/constants';
import UnitSelector from '../UnitSelector/UnitSelector';
import RequestBudgetPopup from '../RequestBudgetPopup/RequestBudgetPopup';
import CheckSaveConfigPopup from '../ConfigPopups/CheckSaveConfigPopup';
import CheckDownloadPdfPopup from '../ConfigPopups/CheckDownloadPdfPopup';
import ContactUsPopup from '../ContactUsPopup/ContactUsPopup';
import CheckForContactBeforeDownloadPopup from '../ContactUsPopup/CheckForContactBeforeDownloadPopup';

const PopupManager = () => {
    const { popupState } = useSelector(state => state.configurator);

    useEffect(() => {
        // console.log(`popupState: ${popupState}`);
    }, [popupState]);

    switch (popupState) {
        case PopupState.Logout:
            return <Logout />;
      case PopupState.UnitSelector:
        return <UnitSelector />;
        case PopupState.Rules:
            return <RulesPopup />;
        case PopupState.SaveConfiguration:
            return <SaveConfigPopup />;
      case PopupState.CheckForSaveConfiguration:
          return <CheckSaveConfigPopup />;
      case PopupState.CheckForDownloadPdf:
        return <CheckDownloadPdfPopup />;
      case PopupState.RequestBudget:
        return <RequestBudgetPopup />;
        case PopupState.LegalNote:
            return <LegalNote />;
        case PopupState.ContactUs:
            return <ContactUsPopup />;
        case PopupState.CheckForContactBeforeDownload:
            return <CheckForContactBeforeDownloadPopup />;
        default:
            return null;
    }
};
export default PopupManager;
